import { useEffect } from 'react';

// Dark mode only - theme picker disabled for now
export const useTheme = () => {
  // Ensure dark theme is applied on mount
  useEffect(() => {
    const root = document.documentElement;
    root.removeAttribute('data-theme'); // Dark is default (no data-theme attribute)
  }, []);

  // No-op functions kept for API compatibility
  const setTheme = () => {};
  const toggleTheme = () => {};

  return {
    theme: 'dark',
    setTheme,
    toggleTheme,
    isDark: true,
    isLight: false,
    isSystem: false,
    actualTheme: 'dark'
  };
};

export default useTheme;